import { useState, useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

export function useAdmin(): { isAdmin: boolean; loading: boolean } {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const checkedRef = useRef(false);

  useEffect(() => {
    if (checkedRef.current) return;
    checkedRef.current = true;

    async function check() {
      try {
        const { data, error } = await supabase.rpc('is_admin');
        if (error) throw error;
        setIsAdmin(data === true);
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    }
    check();
  }, []);

  return { isAdmin, loading };
}
